
	const columns = [
		{
			title: '应用名称',
			dataIndex: 'name'
		},
		{
			title: '授权开通',
			dataIndex: 'isOpen',
			slots: { customRender: 'isOpen' }
		},
		{
			title: '配置信息',
			dataIndex: 'applyMs',
			slots: { customRender: 'applyMs' }
		}
	]
	import { defineComponent, onMounted, reactive, ref, computed, watch } from 'vue'
	import { useStore } from 'vuex'
	import { message } from 'ant-design-vue'
	import { bindApplicationList, bindApplication, getCallLine } from '../request'
	import multiply from '@/common/functions/multiply'
	import { FormState } from '@/types'
	import { BindData } from '../types'
	import deepClone from 'library/functions/deepClone'
	import toast from '@/common/functions/toast'
	import { UpOutlined, DownOutlined } from '@ant-design/icons-vue'
	import SelectLine from './SelectLine.vue'
	import PackageItem from './PackageItem.vue'
	import SeatItem from './SeatItem.vue'

	export default defineComponent({
		components: {
			UpOutlined,
			DownOutlined,
			SelectLine,
			PackageItem,
			SeatItem
		},
		setup(props, { emit }) {
			const store = useStore()
			const detail = computed(() => store.state.business.appDetail)
			const bindDataList = ref<BindData[]>([])
			const formState = reactive<FormState>({
				// 商户 0 朱雀 1 容联
				supplierType: 1,
				// 回调地址
				callbackHost: '',
				zhuqueNum: '',
				//网络电话线路num
				callAccountNum: '',
				//语音线路num
				webCallAccountNum: '',
				//双呼回显线路num
				doubleCallAccountNum: '',
				// 人工外呼账户密码
				accountInfo: {
					accountName: '',
					password: ''
				},
				// 人工外呼费用配置
				callFeeInfo: {
					extenFee: 10, //坐席月租
					airtimeFee: 0.15, //电话单价
					numberFee: 10, //号码月租
					numberCount: 20,
					callPackageFeeInfo: {
						money: '',
						timeMinute: ''
					},
					callExtenInfo: {
						extenCount: 0,
						extens: []
					}
				},
				// 语音播报场景账户信息
				webCallAccountInfo: {
					accountName: '',
					password: '',
					serviceNoVoice: '',
					serviceNo: ''
				},
				// 语音外呼费用配置
				webCallFeeInfo: {
					airtimeFee: 0.15, //电话单价
					concurrencyFee: 0, //并发费
					concurrencyCount: 10,
					numberFee: 10, //号码月租
					numberCount: 20
				},
				// 双呼账户
				doubleCallAccountInfo: {
					proxyUrl: '',
					accountName: '',
					password: '',
					accountId: '',
					pbx: '',
					secretkey: '',
					host: ''
				},
				// 双呼费用
				doubleCallFeeInfo: {
					extenFee: 10,
					airtimeFee: 0.15,
					numberFee: 10,
					numberCount: 20,
					callPackageFeeInfo: {
						money: '',
						timeMinute: ''
					},
					callExtenInfo: {
						extenCount: 0,
						extens: []
					}
				},
				// 短信单价
				unitPrice: 0.05,
				signature: [],
				// 电子合同
				conUnitPrice: 2,
				conCallbackHost: ''
			})
			const formRef = ref()
			// 外呼线路列表
			const callLines = ref([])
			let loading = ref(false)
			// 语音外呼
			const checkedVoice = ref(false)
			const checkedDoubleCall = ref(false)
			const checkedSip = ref(false)

			let showSip = ref(true)
			let showLocal = ref(false)
			let showVoice = ref(false)

			watch(
				() => checkedVoice.value,
				() => {
					if (checkedVoice.value) {
						showVoice.value = true
					}
				}
			)

			watch(
				() => checkedDoubleCall.value,
				() => {
					if (checkedDoubleCall.value) {
						showLocal.value = true
					}
				}
			)

			watch(
				() => checkedSip.value,
				() => {
					if (checkedSip.value) {
						showSip.value = true
					}
				}
			)

			const openCall = computed(() => {
				let findItem = bindDataList.value.find((item) => item.code === 'rengongwaihu')
				return findItem?.isOpen
			})
			const openSms = computed(() => {
				let findItem = bindDataList.value.find((item) => item.code === 'duanxin')
				return findItem?.isOpen
			})
			const openEContract = computed(() => {
				let findItem = bindDataList.value.find((item) => item.code === 'dianzihetong')
				return findItem?.isOpen
			})

			const ok = async (e: MouseEvent) => {
				if (
					openCall.value &&
					formState.supplierType === 1 &&
					!checkedVoice.value &&
					!checkedDoubleCall.value &&
					!checkedSip.value
				) {
					return toast('请选择外呼模式')
				}

				if (checkedVoice.value) {
					showVoice.value = true
				}
				if (checkedDoubleCall.value) {
					showLocal.value = true
				}
				if (checkedSip.value) {
					showSip.value = true
				}

				formRef.value.validate().then(async () => {
					try {
						let params = {
							corpId: detail.value.corpId,
							appList: bindDataList.value.map((item) => {
								let Json = {}
								if (item.code === 'duanxin') {
									Object.assign(Json, {
										unitPrice: multiply(formState?.unitPrice || 0, 100),
										signature: formState.signature || []
									})
								}
								if (item.code === 'rengongwaihu') {
									if ([0, 2].includes(formState.supplierType)) {
										Object.assign(Json, {
											supplierType: formState.supplierType,
											callbackHost: formState.callbackHost,
											wayType: 'local',
											doubleCallAccountNum: formState.zhuqueNum,
											doubleCallFeeInfo: {
												extenFee: multiply(formState.doubleCallFeeInfo.extenFee || 0, 100),
												airtimeFee: multiply(formState.doubleCallFeeInfo.airtimeFee || 0, 100),
												numberFee: multiply(formState.doubleCallFeeInfo.numberFee || 0, 100),
												numberCount: formState.doubleCallFeeInfo.numberCount || 0,
												callPackageFeeInfo: {
													money: multiply(
														+formState.doubleCallFeeInfo.callPackageFeeInfo.money || 0,
														100
													),
													timeMinute:
														formState.doubleCallFeeInfo.callPackageFeeInfo.timeMinute || 0
												}
											},
											doubleCallAccountInfo: formState.doubleCallAccountInfo
										})
									} else if (formState.supplierType === 1) {
										Object.assign(Json, {
											supplierType: 1,
											callbackHost: formState.callbackHost,
											accountInfo: formState.accountInfo,
											callAccountNum: formState.callAccountNum,
											//语音线路num
											webCallAccountNum: formState.webCallAccountNum,
											//双呼回显线路num
											doubleCallAccountNum: formState.doubleCallAccountNum,
											callFeeInfo: {
												extenFee: multiply(formState.callFeeInfo.extenFee || 0, 100),
												airtimeFee: multiply(formState.callFeeInfo.airtimeFee || 0, 100),
												numberFee: multiply(formState.callFeeInfo.numberFee || 0, 100),
												numberCount: formState.callFeeInfo.numberCount || 0,
												callPackageFeeInfo: {
													money: multiply(
														+formState.callFeeInfo.callPackageFeeInfo.money || 0,
														100
													),
													timeMinute: formState.callFeeInfo.callPackageFeeInfo.timeMinute || 0
												},
												callExtenInfo: formState.callFeeInfo.callExtenInfo
											},
											webCallAccountInfo: formState.webCallAccountInfo,
											webCallFeeInfo: {
												concurrencyFee: multiply(
													formState.webCallFeeInfo.concurrencyFee || 0,
													100
												), //并发费
												concurrencyCount: formState.webCallFeeInfo.concurrencyCount || 0,
												airtimeFee: multiply(formState.webCallFeeInfo.airtimeFee || 0, 100),
												numberFee: multiply(formState.webCallFeeInfo.numberFee || 0, 100),
												numberCount: formState.webCallFeeInfo.numberCount || 0
											},
											doubleCallAccountInfo: formState.doubleCallAccountInfo,
											doubleCallFeeInfo: {
												extenFee: multiply(formState.doubleCallFeeInfo.extenFee || 0, 100),
												airtimeFee: multiply(formState.doubleCallFeeInfo.airtimeFee || 0, 100),
												numberFee: multiply(formState.doubleCallFeeInfo.numberFee || 0, 100),
												numberCount: formState.doubleCallFeeInfo.numberCount || 0,
												callPackageFeeInfo: {
													money: multiply(
														+formState.doubleCallFeeInfo.callPackageFeeInfo.money || 0,
														100
													),
													timeMinute:
														formState.doubleCallFeeInfo.callPackageFeeInfo.timeMinute || 0
												},
												callExtenInfo: formState.doubleCallFeeInfo.callExtenInfo
											}
										})
										// "wayType":""//外呼模式 local sip voice
										let ways: string[] = []
										checkedVoice.value && ways.push('voice')
										checkedDoubleCall.value && ways.push('local')
										checkedSip.value && ways.push('sip')
										Object.assign(Json, {
											wayType: ways.join()
										})
									}
								}
								if (item.code === 'dianzihetong') {
									Object.assign(Json, {
										unitPrice: multiply(formState?.conUnitPrice || 0, 100),
										callbackHost: formState.conCallbackHost,
										verifyPrice: 0
									})
								}
								return {
									...item,
									isOpen: item.isOpen ? 1 : 0,
									configJson: JSON.stringify(Json) === '{}' ? null : JSON.stringify(Json)
								}
							})
						}
						loading.value = true
						await bindApplication(params)
						emit('success')
						message.success('保存成功')
						store.commit('toggleAppAddState', false)
					} catch (error) {
						loading.value = false
					}
				})
			}
			const handleChange = () => {
				if (formState.signature.length > 3) {
					message.warn('最多三个短信签名')
					Object.assign(formState, {
						signature: formState.signature.slice(0, 3)
					})
				}
			}
			onMounted(async () => {
				try {
					const params = {
						corpId: detail.value.corpId
					}
					const { data } = await bindApplicationList(params)
					bindDataList.value = data.map((item) => {
						if (item?.configJson) {
							let mix = JSON.parse(item.configJson)
							if (item.code === 'duanxin') {
								Object.assign(formState, {
									unitPrice: multiply(mix?.unitPrice || 5, 0.01),
									signature: mix?.signature || []
								})
							}
							if (item.code == 'rengongwaihu') {
								if (mix?.supplierType === 0 || mix?.supplierType === 2) {
									Object.assign(formState, {
										supplierType: mix?.supplierType,
										zhuqueNum: mix.doubleCallAccountNum,
										callbackHost: mix.callbackHost
									})
									if (mix?.doubleCallFeeInfo) {
										Object.assign(formState.doubleCallFeeInfo, {
											extenFee: multiply(mix.doubleCallFeeInfo.extenFee || 0, 0.01),
											airtimeFee: multiply(mix.doubleCallFeeInfo.airtimeFee || 0, 0.01),
											numberFee: multiply(mix.doubleCallFeeInfo.numberFee || 0, 0.01),
											numberCount: mix.doubleCallFeeInfo.numberCount || 0,
											callPackageFeeInfo: {
												money: multiply(
													mix?.doubleCallFeeInfo?.callPackageFeeInfo?.money || 0,
													0.01
												),
												timeMinute: mix?.doubleCallFeeInfo?.callPackageFeeInfo?.timeMinute
											}
										})
									}
									if (mix?.doubleCallAccountInfo) {
										Object.assign(formState.doubleCallAccountInfo, mix?.doubleCallAccountInfo)
									}
								}
								if (mix?.supplierType === 1) {
									Object.assign(formState, {
										supplierType: 1,
										callbackHost: mix.callbackHost,
										callAccountNum: mix.callAccountNum,
										webCallAccountNum: mix.webCallAccountNum,
										doubleCallAccountNum: mix.doubleCallAccountNum
									})
									if (mix?.accountInfo) {
										Object.assign(formState.accountInfo, mix.accountInfo)
									}
									if (mix?.webCallAccountInfo) {
										Object.assign(formState.webCallAccountInfo, mix.webCallAccountInfo)
									}
									if (mix?.webCallFeeInfo) {
										Object.assign(formState.webCallFeeInfo, {
											airtimeFee: multiply(mix?.webCallFeeInfo?.airtimeFee || 0, 0.01),
											concurrencyFee: multiply(mix?.webCallFeeInfo?.concurrencyFee || 0, 0.01),
											concurrencyCount: mix?.webCallFeeInfo?.concurrencyCount || 0,
											numberFee: multiply(mix?.webCallFeeInfo?.numberFee || 0, 0.01),
											numberCount: mix?.webCallFeeInfo?.numberCount || 0
										})
									}
									if (mix?.callFeeInfo) {
										Object.assign(formState.callFeeInfo, {
											airtimeFee: multiply(mix?.callFeeInfo?.airtimeFee || 0, 0.01),
											extenFee: multiply(mix?.callFeeInfo?.extenFee || 0, 0.01),
											numberCount: mix?.callFeeInfo?.numberCount || 0,
											numberFee: multiply(mix?.callFeeInfo?.numberFee || 0, 0.01),
											callPackageFeeInfo: {
												money: multiply(mix?.callFeeInfo?.callPackageFeeInfo?.money || 0, 0.01),
												timeMinute: mix?.callFeeInfo?.callPackageFeeInfo?.timeMinute
											},
											callExtenInfo: {
												extenCount: mix.callFeeInfo?.callExtenInfo?.extenCount || 0,
												extens: mix.callFeeInfo?.callExtenInfo?.extens || []
											}
										})
									}
									if (mix?.doubleCallAccountInfo) {
										Object.assign(formState.doubleCallAccountInfo, mix?.doubleCallAccountInfo)
									}
									if (mix?.doubleCallFeeInfo) {
										Object.assign(formState.doubleCallFeeInfo, {
											airtimeFee: multiply(mix?.doubleCallFeeInfo?.airtimeFee || 0, 0.01),
											extenFee: multiply(mix?.doubleCallFeeInfo?.extenFee || 0, 0.01),
											numberCount: mix?.doubleCallFeeInfo?.numberCount || 0,
											numberFee: multiply(mix?.doubleCallFeeInfo?.numberFee || 0, 0.01),
											callPackageFeeInfo: {
												money: multiply(
													mix?.doubleCallFeeInfo?.callPackageFeeInfo?.money || 0,
													0.01
												),
												timeMinute: mix?.doubleCallFeeInfo?.callPackageFeeInfo?.timeMinute
											},
											callExtenInfo: {
												extenCount: mix.doubleCallFeeInfo?.callExtenInfo?.extenCount || 0,
												extens: mix.doubleCallFeeInfo?.callExtenInfo?.extens || []
											}
										})
									}
									if (mix?.wayType?.length) {
										if (mix.wayType.includes('local')) {
											checkedDoubleCall.value = true
										}
										if (mix.wayType.includes('sip')) {
											checkedSip.value = true
										}
										if (mix.wayType.includes('voice')) {
											checkedVoice.value = true
										}
									}
								}
							}
							if (item.code === 'dianzihetong') {
								Object.assign(formState, {
									conCallbackHost: mix.callbackHost,
									conUnitPrice: multiply(mix?.unitPrice || 0, 0.01)
								})
							}
						}
						return {
							...item,
							isOpen: Boolean(item.isOpen)
						}
					})
					// const res = await getCallLine({ cropId: detail.value.corpId, bizId: detail.value.id })
					// callLines.value = res.data
				} catch (e) {
					console.log(e)
				}
			})
			return {
				store,
				columns,
				loading,
				formState,
				formRef,
				callLines,
				checkedVoice,
				openCall,
				openSms,
				openEContract,
				ok,
				handleChange,
				bindDataList,
				checkedDoubleCall,
				checkedSip,
				showSip,
				showVoice,
				showLocal
			}
		}
	})
